import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import OrganizationsAPI from '../../../../utils/api/organizationsAPI';

const entity = new ReduxRestEntity({
  name: 'employers',
  api: OrganizationsAPI(),
});

export default entity;
